import { useSearchParams, useNavigate } from 'react-router-dom'
import { useParams } from 'react-router-dom'
import QRCard from '../components/QRCard'
import { CheckCircle2 } from 'lucide-react'

export default function TagReady() {
  const { tagCode } = useParams()
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()

  const name  = searchParams.get('name')  || 'Vehicle Owner'
  const plate = searchParams.get('plate') || ''
  const type  = searchParams.get('type')  || 'car'

  const scanUrl = `${window.location.origin}/scan/${tagCode}${searchParams.get('demo') === '1' ? `?demo=1&name=${encodeURIComponent(name)}&plate=${encodeURIComponent(plate)}&type=${type}` : ''}`

  return (
    <div className="min-h-screen bg-bg text-brand-text font-sans">
      <div className="mx-auto max-w-[480px] px-5 py-10 flex flex-col items-center text-center space-y-6 animate-fade-in">

        {/* Success ring */}
        <div
          className="w-20 h-20 rounded-full flex items-center justify-center"
          style={{
            background: 'rgba(0,229,160,0.12)',
            border: '2px solid rgba(0,229,160,0.35)',
            boxShadow: '0 0 32px rgba(0,229,160,0.2)',
          }}
        >
          <CheckCircle2 size={38} className="text-accent" />
        </div>

        <div>
          <h1 className="font-syne font-extrabold text-3xl mb-2">Your Tag is Ready!</h1>
          <p className="text-sm text-brand-muted leading-relaxed max-w-xs mx-auto">
            Save or share your QR tag. Stick it on your windshield — anyone can scan it to reach you privately.
          </p>
        </div>

        {/* QR Card */}
        <div className="w-full">
          <QRCard url={scanUrl} name={name} plate={plate} type={type} />
        </div>

        {/* Instructions */}
        <div
          className="w-full rounded-2xl p-4 text-left space-y-3"
          style={{ background: '#13131a', border: '1px solid rgba(255,255,255,0.07)' }}
        >
          <p className="text-xs font-semibold text-brand-muted uppercase tracking-wider">How to use</p>
          {(type === 'pet'
            ? [
                { icon: '⬇️', text: 'Save the QR image to your phone' },
                { icon: '🖨️', text: 'Print it out or use a sticker service' },
                { icon: '🐾', text: 'Attach it to your pet\'s collar or tag' },
                { icon: '📲', text: 'Anyone who scans can reach you — number stays hidden' },
              ]
            : type === 'child'
            ? [
                { icon: '⬇️', text: 'Save the QR image to your phone' },
                { icon: '🖨️', text: 'Print it out or use a sticker service' },
                { icon: '👶', text: 'Put it on your child\'s bag, clothing or wristband' },
                { icon: '📲', text: 'Anyone who scans can reach you — number stays hidden' },
              ]
            : [
                { icon: '⬇️', text: 'Save the QR image to your phone' },
                { icon: '🖨️', text: 'Print it out or use a sticker service' },
                { icon: '🚗', text: 'Stick it on your windshield or number plate area' },
                { icon: '📲', text: 'Anyone who scans can reach you — number stays hidden' },
              ]
          ).map(({ icon, text }) => (
            <div key={text} className="flex items-center gap-3">
              <span className="text-lg">{icon}</span>
              <p className="text-sm text-brand-muted">{text}</p>
            </div>
          ))}
        </div>

        {/* Preview scanner */}
        <button
          onClick={() => navigate(`/scan/${tagCode}${searchParams.get('demo') === '1' ? `?demo=1&name=${encodeURIComponent(name)}&plate=${encodeURIComponent(plate)}&type=${type}` : ''}`)}
          className="w-full py-3.5 rounded-2xl font-syne font-bold text-sm transition-all hover:opacity-90 active:scale-95"
          style={{
            background: 'rgba(0,229,160,0.1)',
            border: '1px solid rgba(0,229,160,0.3)',
            color: '#00e5a0',
          }}
        >
          👀 Preview what scanner sees
        </button>

        {/* Go to dashboard */}
        <button
          onClick={() => navigate('/dashboard')}
          className="w-full py-4 rounded-2xl font-syne font-bold text-bg text-base transition-all hover:opacity-90 active:scale-95"
          style={{ background: '#00e5a0', boxShadow: '0 0 24px rgba(0,229,160,0.35)' }}
        >
          Go to Dashboard →
        </button>

        <p className="text-xs text-brand-muted pb-4">
          Park<span className="text-accent font-semibold">Ping</span> · Privacy-first parking contacts
        </p>
      </div>
    </div>
  )
}
